// Generated with tools/create-component.js
import React, { useState } from "react";
import { Carousel, CarouselTypes, CmsContent, Container, Icon, Image } from "components";
import { useSwiperRef } from "hooks";
import { ContainerWidthEnum } from "utils";
import { SliderTestimonialQueryFragment } from "codegen";
import "./SliderTestimonial.scss";

export const SliderTestimonial: React.FC<SliderTestimonialQueryFragment> = ({ data: { testimonials, image } }) => {
  const [nextEl, nextElRef] = useSwiperRef<HTMLDivElement>();
  const [prevEl, prevElRef] = useSwiperRef<HTMLDivElement>();
  const [currentSlide, setCurrentSlide] = useState(1);

  const swiperSettings: CarouselTypes = {
    slidesPerView: 1,
    centeredSlides: true,
    grabCursor: false,
    pagination: false,
    navigation: {
      prevEl,
      nextEl,
    },
  };

  return (
    <Container className="slider-testimonial" containerWidth={ContainerWidthEnum["FULL_BLEED_LARGE"]}>
      <div className="slider-testimonial__image">
        <Image src={image} />
      </div>
      <div className="slider-testimonial__slider">
        <h3 className="slider-testimonial__heading">Testimonials</h3>
        {testimonials && Object.keys(testimonials).length > 0 && (
          <Carousel swiperSettings={swiperSettings}>
            {testimonials?.map((testimonial) => {
              return (
                <div className="slider-testimonial__slide" key={testimonial?.id}>
                  <blockquote className="slider-testimonial__slide__quote">
                    <CmsContent content={testimonial?.content} />
                  </blockquote>
                  <figcaption className="slider-testimonial__slide__caption">
                    {testimonial?.acfTestimonials?.reference}
                  </figcaption>
                  {testimonial?.acfTestimonials?.logo && (
                    <div className="slider-testimonial__slide__logo">
                      <Image
                        src={testimonial?.acfTestimonials?.logo}
                        alt={testimonial?.acfTestimonials?.logo?.altText}
                      />
                    </div>
                  )}
                </div>
              );
            })}
          </Carousel>
        )}
      </div>
      <div className="slider-testimonial__controls">
        <div
          ref={prevElRef}
          className="slider-testimonial__controls__navigation-button"
          onClick={() => (currentSlide !== 1 ? setCurrentSlide(currentSlide - 1) : null)}
        >
          <Icon name="ArrowLeft" size={5} />
        </div>
        <p className="slider-testimonial__controls__indicator">
          {currentSlide}/{testimonials.length}
        </p>
        <div
          ref={nextElRef}
          className="slider-testimonial__controls__navigation-button"
          onClick={() => (currentSlide !== testimonials.length ? setCurrentSlide(currentSlide + 1) : null)}
        >
          <Icon name="ArrowRight" size={5} />
        </div>
      </div>
    </Container>
  );
};
